import Sharing from 'app/developer-v3/pages/sharing';

export default {
  routes: {
    '.': Sharing,
  },
};
